import { render, staticRenderFns } from "./EmployeeAdmin.vue?vue&type=template&id=b523d892"
import script from "./EmployeeAdmin.vue?vue&type=script&lang=js"
export * from "./EmployeeAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b523d892')) {
      api.createRecord('b523d892', component.options)
    } else {
      api.reload('b523d892', component.options)
    }
    module.hot.accept("./EmployeeAdmin.vue?vue&type=template&id=b523d892", function () {
      api.rerender('b523d892', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/EmployeeAdmin.vue"
export default component.exports